import { previewMergeRuleSlice } from "./PreviewMergeRule.redux"

export const {  
    updatePreviewMergeRuleUserInput,
    resetStatusForMergePreviewForRecommendationApi
} = previewMergeRuleSlice.actions